module.exports = __webpack_public_path__ + "img/四川天府新区新兴小学（庙山）校区.f417ec16.jpg";